import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig, withPreloading, NoPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { IMAGE_CONFIG, IMAGE_LOADER, ImageLoaderConfig, LocationStrategy } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { WEB_CDN_URL } from './global_constant';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { AttributionPreservingPathLocationStrategy } from './services/attribution-preserving-location.strategy';


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    // Keep gclid/fbclid/utm_*/ads *clid in the address bar on every URL rewrite (all pages).
    { provide: LocationStrategy, useClass: AttributionPreservingPathLocationStrategy },
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'ignore',
        urlUpdateStrategy: 'eager',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled', // This is the key!
        anchorScrolling: 'enabled',
      }),
      withPreloading(NoPreloading)
    ), provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        filter: (req) => {
          return !req.url.includes('location-menu');
        }
      })
    ),
    { provide: IMAGE_CONFIG, useValue: { disableImageSizeWarning: true, disableImageLazyLoadWarning: true } },
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        if (config.src.startsWith('http://') || config.src.startsWith('https://')) {
          return config.src;
        }

        if (config.src.startsWith('local/')) {
          const localSrc = config.src.replace('local/', '');
          return `/assets/images/${localSrc}`;
        }

        let src = config.src;
        if (src.startsWith('assets/images/')) {
          src = src.replace('assets/images/', '');
        } else if (src.startsWith('/assets/images/')) {
          src = src.replace('/assets/images/', '');
        }
        const widthParam = config.width ? `?width=${config.width}` : '';
        return `${WEB_CDN_URL}assets/images/${src}${widthParam}`;
      }
    },
    providePrimeNG({
      theme: {
        preset: Aura,
        options:{
          darkModeSelector: false
        }
      }
    }),
    importProvidersFrom(
      ModalModule.forRoot(),
      BsDatepickerModule.forRoot(),
      ToastrModule.forRoot({
        positionClass: 'toast-top-full-width'
      })
    ),
    DatePipe,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: "6LdQg7srAAAAAPFPwzL-pTUzz7Ezr7jTQwO3UR5t"
    }
  ]
};
